import { c as _c } from "react/compiler-runtime";
import { FUNNEL_EMAIL_API } from 'modules/funnels/funnel/components/email-tab/api/funnel-email-api';
import { FunnelEmailViewInterface, FunnelEmailsApiInterface } from 'modules/funnels/funnel/components/email-tab/types/funnel-emails-interface';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useOnceTrue } from 'shared/hooks/use-once-true';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import useSWR from 'swr';
interface UseFunnelEmailsInterface extends SwrPaginationInterface {
  funnelStepId?: FunnelStepId;
}
export const useFunnelEmails = t0 => {
  const $ = _c(6);
  const {
    limit,
    pagination,
    funnelStepId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== funnelStepId || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (!user || !funnelStepId) {
        return;
      }
      if (user) {
        return `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails?${getPaginationQueryString({
          pagination,
          limit
        })}`;
      }
      return null;
    };
    $[1] = funnelStepId;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useSWR(t2, fetcher);
};
export const useFunnelEmail = (funnelStepId, emailId, opened) => {
  const $ = _c(8);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const allowed = useOnceTrue(!!user && !!funnelStepId && !!emailId && !!opened);
  let t1;
  if ($[1] !== allowed || $[2] !== emailId || $[3] !== funnelStepId) {
    t1 = () => {
      if (!allowed) {
        return;
      }
      return `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails/${emailId}`;
    };
    $[1] = allowed;
    $[2] = emailId;
    $[3] = funnelStepId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: emailData,
    mutate: mutateEmailData
  } = useSWR(t1, fetcher);
  let t2;
  if ($[5] !== emailData || $[6] !== mutateEmailData) {
    t2 = {
      emailData,
      mutateEmailData
    };
    $[5] = emailData;
    $[6] = mutateEmailData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const useFunnelEmailInfoSender = funnelStepId => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== funnelStepId || $[2] !== user) {
    t1 = () => {
      if (!user || !funnelStepId) {
        return;
      }
      return `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails/sender-info`;
    };
    $[1] = funnelStepId;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useSWR(t1, fetcher);
};